'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.walletDefinitions = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _u2fApi = require('u2f-api');

var _reactDeviceDetect = require('react-device-detect');

var _browserProviderIsSupported = require('./browserProviderIsSupported');

var _browserProviderIsSupported2 = _interopRequireDefault(_browserProviderIsSupported);

var _constants = require('../constants');

var _ExternalWalletOptions = require('../components/ExternalWalletOptions');

var _ExternalWalletOptions2 = _interopRequireDefault(_ExternalWalletOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// eslint-disable-next-line import/prefer-default-export
var walletDefinitions = exports.walletDefinitions = [{
  name: 'Browser Wallet',
  type: 'browser',
  description: 'Use a browser wallet (e.g., MetaMask or Parity)',
  isSupported: _browserProviderIsSupported2.default,
  isInteractive: true,
  enablePolling: true,
  getOptionsComponent: function getOptionsComponent() {
    return null;
  },
  poolSize: 2,
  timeout: _constants.LONG_TIMEOUT
}, {
  name: 'Ledger Wallet',
  type: 'ledger',
  description: 'Use a Ledger Nano S or Blue Hardware Wallet',
  isSupported: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var isBrowser, regex, isFirefox;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isBrowser = typeof navigator !== 'undefined' && !!navigator.userAgent;
              regex = RegExp(/Firefox\//i);
              isFirefox = isBrowser && regex.test(navigator.userAgent);
              // isSupported can return true for some mobile browsers and firefox,
              // but they do not implement u2f-api in ways that are needed for ledger communication,
              // explicitly avoid them for now.

              if (!(!_reactDeviceDetect.isMobile || !isFirefox)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt('return', (0, _u2fApi.isSupported)());

            case 5:
              return _context.abrupt('return', false);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    function isSupported() {
      return _ref.apply(this, arguments);
    }

    return isSupported;
  }(),
  isInteractive: true,
  enablePolling: false,
  getOptionsComponent: function getOptionsComponent() {
    return null;
  },
  poolSize: 1,
  timeout: _constants.LEDGER_TIMEOUT
}, {
  name: 'External Wallet',
  type: 'external',
  isInteractive: false,
  description: 'Use an external wallet (e.g., MEW or MyCrypto)',
  isSupported: function isSupported() {
    return Promise.resolve(true);
  },
  enablePolling: false,
  getOptionsComponent: function getOptionsComponent() {
    return _ExternalWalletOptions2.default;
  },
  poolSize: 2,
  timeout: _constants.LONG_TIMEOUT
}];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/utilities/walletTypes.js
// module id = 108
// module chunks = 0